<div class="">

    <mat-form-field class="input-field-wrapper">
        <mat-label>{{ "DOCUMENT_UPLOAD_COMPONENT.LABELS.NAME" | translate }}&nbsp;*</mat-label>
        <input matInput [(ngModel)]="document['name']" id="name" required>
    </mat-form-field>

    <mat-form-field class="input-field-wrapper" *ngIf="isChemicalDocument() && !selfDeclarationUpload">
        <mat-label>{{ "DOCUMENT_UPLOAD_COMPONENT.LABELS.TYPE" | translate }}&nbsp;*</mat-label>
        <mat-select [(ngModel)]="document['category']" id="type" required>
            <mat-option value="SDS">{{ "DOCUMENT_UPLOAD_COMPONENT.TYPE_SELECT.SDS" | translate }}</mat-option>
            <mat-option value="TDS">{{ "DOCUMENT_UPLOAD_COMPONENT.TYPE_SELECT.TDS" | translate }}</mat-option>
            <mat-option value="Test Report">{{ "DOCUMENT_UPLOAD_COMPONENT.TYPE_SELECT.TEST" | translate }}</mat-option>
            <mat-option value="STeP Declaration Letter">{{ "DOCUMENT_UPLOAD_COMPONENT.TYPE_SELECT.SELF_DECLARATION" |
                translate
                }}
            </mat-option>
            <mat-option value="Certificate">{{ "DOCUMENT_UPLOAD_COMPONENT.TYPE_SELECT.CERTIFICATE" | translate }}
            </mat-option>
            <mat-option value="Other">{{ "DOCUMENT_UPLOAD_COMPONENT.TYPE_SELECT.OTHER" | translate }}</mat-option>
        </mat-select>
    </mat-form-field>

    <!-- <mat-form-field class="input-field-wrapper" *ngIf="selfDeclarationUpload">
        <mat-label>{{ "DOCUMENT_UPLOAD_COMPONENT.LABELS.TYPE" | translate }}</mat-label>
        <mat-select [(ngModel)]="document['category']" id="type" required>
         
            <mat-option value="STeP Declaration Letter">{{ "DOCUMENT_UPLOAD_COMPONENT.TYPE_SELECT.SELF_DECLARATION" |
                translate
                }}
            </mat-option>
             
        </mat-select>
    </mat-form-field> -->


    <mat-form-field class="input-field-wrapper" *ngIf="!isChemicalDocument()">
        <mat-label>{{ "DOCUMENT_UPLOAD_COMPONENT.LABELS.TYPE" | translate }}&nbsp;*</mat-label>
        <mat-select [(ngModel)]="document['category']" id="type" required>
            <mat-option *ngIf="!this.testWater" value="Test Report">{{ "DOCUMENT_UPLOAD_COMPONENT.TYPE_SELECT.TEST" |
                translate }}</mat-option>
            <mat-option value="Audit Report">{{ "DOCUMENT_UPLOAD_COMPONENT.TYPE_SELECT.AUDIT" | translate }}
            </mat-option>
            <mat-option value="Certificate">{{ "DOCUMENT_UPLOAD_COMPONENT.TYPE_SELECT.CERTIFICATE" | translate }}
            </mat-option>
            <mat-option value="Policy">{{ "DOCUMENT_UPLOAD_COMPONENT.TYPE_SELECT.POLICY" | translate }}</mat-option>
            <mat-option value="SOP">{{ "DOCUMENT_UPLOAD_COMPONENT.TYPE_SELECT.SOP" | translate }}</mat-option>
            <mat-option value="Other">{{ "DOCUMENT_UPLOAD_COMPONENT.TYPE_SELECT.OTHER" | translate }}</mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field class="input-field-wrapper" *ngIf="!isChemicalDocument()">
        <mat-label>{{ "DOCUMENT_UPLOAD_COMPONENT.LABELS.RESULT" | translate }}&nbsp;*</mat-label>
        <mat-select [(ngModel)]="document['passFail']" id="result" required>
            <mat-option value="true">{{ "DOCUMENT_UPLOAD_COMPONENT.RESULT_SELECT.PASSED" | translate }}</mat-option>
            <mat-option value="false">{{ "DOCUMENT_UPLOAD_COMPONENT.RESULT_SELECT.FAILED" | translate }}</mat-option>
            <mat-option value="null">{{ "DOCUMENT_UPLOAD_COMPONENT.RESULT_SELECT.NA" | translate }}</mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field class="input-field-wrapper">
        <mat-label>{{ "DOCUMENT_UPLOAD_COMPONENT.LABELS.ISSUE_DATE" | translate }}&nbsp;*</mat-label>
        <input matInput [matDatepicker]="picker1" [max]="document['expiryDate']" (dateChange)="updateIssueDate($event)"
            [(ngModel)]="issueDate" id="issue">
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>

    </mat-form-field>
    <mat-form-field class="input-field-wrapper">
        <mat-label>{{ "DOCUMENT_UPLOAD_COMPONENT.LABELS.EXPIRY_DATE" | translate }}</mat-label>
        <input matInput [matDatepicker]="picker2" [min]="document['issueDate']" (dateChange)="updateExpiryDate($event)"
            [(ngModel)]="expiryDate" id="expiry">
        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="input-field-wrapper">
        <mat-label>{{ "DOCUMENT_UPLOAD_COMPONENT.LABELS.COMMENT" | translate }}</mat-label>
        <input class="w-94" matInput [(ngModel)]="document['comment']" id="comment">
    </mat-form-field>

    <br>

    <div class="input-field-wrapper file-input-wrapper">
        <div class="inline-div">
            <label>{{ "DOCUMENT_UPLOAD_COMPONENT.LABELS.FILE_SELECT" | translate }}*</label>
            <input type="file" (change)="addFile($event.target.files)" id="file">
        </div>
        <div class="inline-div">
            <button *ngIf="hasFile()" (click)="clearContent()">
                <mat-icon class="clear-button-icon">cancel</mat-icon>
            </button>
        </div>
    </div>

    <div>
        <input [(ngModel)]="docConditionCheck" type="checkbox">
        <span>
            &nbsp;I agree with T&C and aware that uploaded document will be visible to
            connected brands
        </span>
    </div>

    <!-- <button   class="btn btn-secondary" (click)="cancel()">{{
        "DOCUMENT_UPLOAD_COMPONENT.BUTTONS.CANCEL" | translate
        }}</button> -->

    <button class="ml-4 btn btn-primary" (click)="upload()" [disabled]="!docConditionCheck">{{
        "DOCUMENT_UPLOAD_COMPONENT.BUTTONS.UPLOAD" | translate }}</button>
</div>